import { Injectable, EventEmitter } from '@angular/core';
import { IKart, IKartTuru, IIcerik, IVT, IYollar } from '@/src/service/fikoyt-ui/interfaces/IKart.interface';
import { IParametreSetiGrubu } from '@/src/service/fikoyt-ui/interfaces/IParametreSeti.interface';
import { ISablon } from '@/src/service/fikoyt-ui/src/lib/paylasim-sistemi/sablon-editoru/sablon.interface';
import { FikoYTId } from '@/src/service/fikoyt-ui/helpers/FikoYTId';
import { personelAcilirKutu, departmanAcilirKutu } from '../projeler/hmi-ortak-helpers';

const UYG = 'FikoYT.sistem.hmi.yonetim';

@Injectable({ providedIn: 'root' })
export class HmiYonetimService {
  paylasimYapildi = new EventEmitter<any>(true);
  aktifIcerikNo = 0;

  kart: IKart = {
    _id: new FikoYTId().toString(),
    vt: 'FikoYT.sistem.hareketler' as IVT,
    yol: 'FikoYT.sistem.hareketler.kalem' as IYollar,
    turu: IKartTuru.KART,
    gizlilik: 'Herkese Açık',
    kisiler: [],
    veri: {
      solSimge: { aciklama: undefined, baslik: 'HMI', renkArka: '#722ed1', renkYazi: '#fff' },
      kurdela: { aciklama: undefined, baslik: 'Yönetim', renkArka: undefined, renkYazi: undefined },
      icerikler: [
        { _id: new FikoYTId().toString(), html: '', aciklama: '', sifre: null } as IIcerik,
      ],
    },
  };

  readonly parametreSetleri: IParametreSetiGrubu[] = [
    /* {
      id: 'hmi.personel',
      baslik: 'Personel',
      simge: '👤',
      aciklama: 'Personel kaydı oluştur',
      renk: 'linear-gradient(135deg, #0d47a1, #1e88e5)',
      kaynak: 'kod',
      bilesen: 'personel',
      parametreler: [
        { turu: 'Yazı', ismi: 'ad', baslik: 'Ad', ayarlar: { zorunlu: true } },
        { turu: 'Yazı', ismi: 'soyad', baslik: 'Soyad', ayarlar: { zorunlu: true } },
        { turu: 'Yazı', ismi: 'sicilNo', baslik: 'Sicil No' },
        departmanAcilirKutu('departman', 'Departman'),
        { turu: 'Yazı', ismi: 'unvan', baslik: 'Ünvan' },
        { turu: 'Yazı', ismi: 'gorev', baslik: 'Görev' },
        { turu: 'Yazı', ismi: 'telefon', baslik: 'Telefon', ayarlar: { solSimge: '📱' } },
        { turu: 'Yazı', ismi: 'eposta', baslik: 'E-posta', ayarlar: { solSimge: '📧' } },
        { turu: 'Tarih', ismi: 'iseGirisTarihi', baslik: 'İşe Giriş Tarihi' },
      ],
      sablon: {
        genislik: 520, yukseklik: 160, mod: 'serbest',
        arkaPlan: { tur: 'gradient', deger: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 100%)' },
        bolgeler: [],
        elementler: [
          // Sol accent çizgi
          { id: 'pe0', tur: 'sekil', sekilTuru: 'dikdortgen', x: 0, y: 0, genislik: 5, yukseklik: 160, stil: { fill: '#3b82f6' } },
          // Avatar daire arka plan
          { id: 'pe1a', tur: 'sekil', sekilTuru: 'daire', x: 5, y: 18, genislik: 72, yukseklik: 72, stil: { fill: 'rgba(59,130,246,0.15)', stroke: 'rgba(59,130,246,0.3)', strokeWidth: 2 } },
          { id: 'pe1', tur: 'sabit-metin', icerik: '👤', x: 5, y: 18, genislik: 72, yukseklik: 72, stil: { fontSize: 32, textAlign: 'center', verticalAlign: 'center' } },
          // Ad soyad
          { id: 'pe2', tur: 'parametre-metin', parametreAnahtari: 'ad', x: 22, y: 20, genislik: 180, yukseklik: 30, stil: { fontSize: 20, fontWeight: '700', color: '#f1f5f9', verticalAlign: 'center' } },
          { id: 'pe2a', tur: 'parametre-metin', parametreAnahtari: 'soyad', x: 22, y: 38, genislik: 220, yukseklik: 26, stil: { fontSize: 16, fontWeight: '500', color: '#93c5fd', verticalAlign: 'center' } },
          // Ünvan chip
          { id: 'pe3bg', tur: 'sekil', sekilTuru: 'dikdortgen', x: 22, y: 60, genislik: 140, yukseklik: 22, stil: { fill: 'rgba(59,130,246,0.12)', borderRadius: 11 } },
          { id: 'pe3', tur: 'parametre-metin', parametreAnahtari: 'unvan', x: 22, y: 60, genislik: 140, yukseklik: 22, stil: { fontSize: 10, fontWeight: '500', color: '#60a5fa', textAlign: 'center', verticalAlign: 'center' } },
          // Alt çizgi
          { id: 'pe4', tur: 'sekil', sekilTuru: 'dikdortgen', x: 3, y: 88, genislik: 92, yukseklik: 1, stil: { fill: 'rgba(255,255,255,0.06)' } },
          // Etiket
          { id: 'pe7', tur: 'sabit-metin', icerik: 'PERSONEL', x: 3, y: 90, genislik: 92, yukseklik: 14, stil: { fontSize: 7, fontWeight: '700', color: 'rgba(148,163,184,0.35)', verticalAlign: 'center', letterSpacing: 3, textAlign: 'center' } },
        ],
      } as ISablon,
      altKartSablonlari: [
        { id: 'hmi.personel.adres', baslik: 'Adres Bilgisi', simge: '📍', bilesen: 'adres-bilgisi' },
        { id: 'hmi.personel.izin', baslik: 'İzin Kaydı', simge: '📅', bilesen: 'izin-kaydi' },
        { id: 'hmi.personel.egitim', baslik: 'Eğitim Kaydı', simge: '📚', bilesen: 'egitim-kaydi' },
      ],
    },
    {
      id: 'hmi.departman',
      baslik: 'Departman',
      simge: '🏢',
      aciklama: 'Departman tanımla',
      renk: 'linear-gradient(135deg, #bf360c, #ff6e40)',
      kaynak: 'kod',
      bilesen: 'departman',
      parametreler: [
        { turu: 'Yazı', ismi: 'departmanAdi', baslik: 'Departman Adı', ayarlar: { zorunlu: true } },
        { turu: 'Yazı', ismi: 'departmanKodu', baslik: 'Departman Kodu' },
        departmanAcilirKutu('ustDepartman', 'Üst Departman'),
        personelAcilirKutu('yonetici', 'Departman Yöneticisi'),
        { turu: 'Renk', ismi: 'renk', baslik: 'Renk' },
        { turu: 'Yazı Alanı', ismi: 'aciklama', baslik: 'Açıklama' },
      ],
      sablon: {
        genislik: 520, yukseklik: 130, mod: 'serbest',
        arkaPlan: { tur: 'gradient', deger: 'linear-gradient(135deg, #1a0a00 0%, #7c2d12 100%)' },
        bolgeler: [],
        elementler: [
          // Sol accent
          { id: 'dp0', tur: 'sekil', sekilTuru: 'dikdortgen', x: 0, y: 0, genislik: 5, yukseklik: 130, stil: { fill: '#f97316' } },
          // İkon
          { id: 'dp1', tur: 'sabit-metin', icerik: '🏢', x: 5, y: 16, genislik: 56, yukseklik: 56, stil: { fontSize: 28, textAlign: 'center', verticalAlign: 'center' } },
          // Departman adı
          { id: 'dp2', tur: 'parametre-metin', parametreAnahtari: 'departmanAdi', x: 18, y: 20, genislik: 360, yukseklik: 30, stil: { fontSize: 20, fontWeight: '700', color: '#fed7aa', verticalAlign: 'center' } },
          // Kod chip
          { id: 'dp3bg', tur: 'sekil', sekilTuru: 'dikdortgen', x: 18, y: 52, genislik: 100, yukseklik: 20, stil: { fill: 'rgba(249,115,22,0.15)', borderRadius: 10 } },
          { id: 'dp3', tur: 'parametre-metin', parametreAnahtari: 'departmanKodu', x: 18, y: 52, genislik: 100, yukseklik: 20, stil: { fontSize: 9, fontWeight: '600', color: '#fb923c', textAlign: 'center', verticalAlign: 'center', letterSpacing: 1 } },
          // Alt çizgi + etiket
          { id: 'dp6', tur: 'sekil', sekilTuru: 'dikdortgen', x: 3, y: 82, genislik: 92, yukseklik: 1, stil: { fill: 'rgba(255,255,255,0.06)' } },
          { id: 'dp7', tur: 'sabit-metin', icerik: 'DEPARTMAN', x: 3, y: 84, genislik: 92, yukseklik: 14, stil: { fontSize: 7, fontWeight: '700', color: 'rgba(251,146,60,0.3)', verticalAlign: 'center', letterSpacing: 3, textAlign: 'center' } },
        ],
      } as ISablon,
      altKartSablonlari: [
        { id: 'hmi.departman.duyuru', baslik: 'Duyuru', simge: '📢', bilesen: 'duyuru' },
      ],
    },
    {
      id: 'hmi.tedarikci',
      baslik: 'Tedarikçi',
      simge: '🏭',
      aciklama: 'Tedarikçi / firma kaydı',
      renk: 'linear-gradient(135deg, #4a148c, #ab47bc)',
      kaynak: 'kod',
      bilesen: 'tedarikci',
      parametreler: [
        { turu: 'Yazı', ismi: 'firmaAdi', baslik: 'Firma Adı', ayarlar: { zorunlu: true } },
        { turu: 'Yazı', ismi: 'yetkili', baslik: 'Yetkili Kişi' },
        { turu: 'Yazı', ismi: 'telefon', baslik: 'Telefon', ayarlar: { solSimge: '📱' } },
        { turu: 'Yazı', ismi: 'eposta', baslik: 'E-posta', ayarlar: { solSimge: '📧' } },
        { turu: 'Yazı', ismi: 'adres', baslik: 'Adres' },
        { turu: 'Yazı', ismi: 'vergiNo', baslik: 'Vergi No' },
        { turu: 'Açılır Kutu', ismi: 'kategori', baslik: 'Kategori', ayarlar: {
          secenekler: [
            { label: 'Hammadde', value: 'Hammadde' }, { label: 'Yardımcı Malzeme', value: 'Yardımcı Malzeme' },
            { label: 'Makine/Ekipman', value: 'Makine/Ekipman' }, { label: 'Hizmet', value: 'Hizmet' },
            { label: 'Lojistik', value: 'Lojistik' }, { label: 'Diğer', value: 'Diğer' },
          ],
        } },
        { turu: 'Yazı Alanı', ismi: 'notlar', baslik: 'Notlar' },
      ],
      sablon: {
        genislik: 520, yukseklik: 140, mod: 'serbest',
        arkaPlan: { tur: 'gradient', deger: 'linear-gradient(135deg, #0f0720 0%, #312e81 100%)' },
        bolgeler: [],
        elementler: [
          { id: 'td0', tur: 'sekil', sekilTuru: 'dikdortgen', x: 0, y: 0, genislik: 5, yukseklik: 140, stil: { fill: '#8b5cf6' } },
          // İkon
          { id: 'td1', tur: 'sabit-metin', icerik: '🏭', x: 5, y: 16, genislik: 56, yukseklik: 56, stil: { fontSize: 28, textAlign: 'center', verticalAlign: 'center' } },
          // Firma adı
          { id: 'td2', tur: 'parametre-metin', parametreAnahtari: 'firmaAdi', x: 18, y: 18, genislik: 380, yukseklik: 28, stil: { fontSize: 18, fontWeight: '700', color: '#e0e7ff', verticalAlign: 'center' } },
          // Yetkili
          { id: 'td3', tur: 'parametre-metin', parametreAnahtari: 'yetkili', x: 18, y: 42, genislik: 300, yukseklik: 20, stil: { fontSize: 12, fontWeight: '400', color: '#a5b4fc', verticalAlign: 'center' } },
          // Kategori chip
          { id: 'td4bg', tur: 'sekil', sekilTuru: 'dikdortgen', x: 18, y: 62, genislik: 110, yukseklik: 20, stil: { fill: 'rgba(139,92,246,0.15)', borderRadius: 10 } },
          { id: 'td4', tur: 'parametre-metin', parametreAnahtari: 'kategori', x: 18, y: 62, genislik: 110, yukseklik: 20, stil: { fontSize: 9, fontWeight: '500', color: '#a78bfa', textAlign: 'center', verticalAlign: 'center' } },
          // Etiket
          { id: 'td6', tur: 'sekil', sekilTuru: 'dikdortgen', x: 3, y: 88, genislik: 92, yukseklik: 1, stil: { fill: 'rgba(255,255,255,0.06)' } },
          { id: 'td9', tur: 'sabit-metin', icerik: 'TEDARİKÇİ', x: 3, y: 90, genislik: 92, yukseklik: 14, stil: { fontSize: 7, fontWeight: '700', color: 'rgba(167,139,250,0.3)', verticalAlign: 'center', letterSpacing: 3, textAlign: 'center' } },
        ],
      } as ISablon,
      altKartSablonlari: [
        { id: 'hmi.tedarikci.degerlendirme', baslik: 'Değerlendirme', simge: '⭐', bilesen: 'degerlendirme' },
      ],
    },
    {
      id: 'hmi.bakim-talebi',
      baslik: 'Bakım Talebi',
      simge: '🔧',
      aciklama: 'Arıza ve bakım talebi oluştur',
      renk: 'linear-gradient(135deg, #b71c1c, #e53935)',
      kaynak: 'kod',
      bilesen: 'bakim-talebi',
      altGruplar: [
        {
          id: 'hmi.bakim-talebi.ekle',
          baslik: 'Yeni Talep',
          simge: '🔧',
          aciklama: 'Bakım talebi oluştur',
          parametreler: [
            { turu: 'Otomatik Kod', ismi: 'talepNo', baslik: 'Talep No', ayarlar: { kodFormat: '{PREFIX}-{YIL}-{AY}-{SAYI:3}', kodPrefix: 'BT' } },
            { turu: 'Yazı', ismi: 'makine', baslik: 'Makine', ayarlar: { zorunlu: true } },
            {
              turu: 'Açılır Kutu', ismi: 'arizaTuru', baslik: 'Arıza Türü', ayarlar: {
                itemSablon: { aktif: true, simgeGoster: true, renkGoster: false, aciklamaGoster: false, resimGoster: false },
                secenekler: [
                  { label: 'Mekanik', value: 'Mekanik', simge: '🔩' },
                  { label: 'Elektrik', value: 'Elektrik', simge: '⚡' },
                  { label: 'Hidrolik', value: 'Hidrolik', simge: '💧' },
                  { label: 'Pnömatik', value: 'Pnömatik', simge: '💨' },
                  { label: 'Yazılım', value: 'Yazılım', simge: '💻' },
                  { label: 'Diğer', value: 'Diğer', simge: '❓' },
                ],
              }
            },
            {
              turu: 'Açılır Kutu', ismi: 'aciliyet', baslik: 'Aciliyet', ayarlar: {
                itemSablon: { aktif: true, simgeGoster: false, renkGoster: true, aciklamaGoster: false, resimGoster: false },
                secenekler: [
                  { label: 'Düşük', value: 'Düşük', renk: '#8c8c8c' },
                  { label: 'Orta', value: 'Orta', renk: '#fa8c16' },
                  { label: 'Yüksek', value: 'Yüksek', renk: '#f5222d' },
                  { label: 'Acil Durum', value: 'Acil Durum', renk: '#a8071a' },
                ],
              }
            },
            { turu: 'Yazı Alanı', ismi: 'aciklama', baslik: 'Açıklama', ayarlar: { zorunlu: true } },
            personelAcilirKutu('raporEden', 'Rapor Eden'),
          ],
          sayfaKurallari: { yeniSayfaEngelle: true },
          sablon: {
            genislik: 520, yukseklik: 220, mod: 'serbest',
            arkaPlan: { tur: 'gradient', deger: 'linear-gradient(145deg, #3a0a0a 0%, #b71c1c 50%, #e53935 100%)' },
            bolgeler: [],
            elementler: [
              { id: 'bt0', tur: 'sekil', sekilTuru: 'dikdortgen', x: 0, y: 0, genislik: 520, yukseklik: 5, stil: { fill: 'rgba(255,255,255,0.15)' } },
              { id: 'bt1', tur: 'sabit-metin', icerik: '🔧', x: 5, y: 8, genislik: 50, yukseklik: 50, stil: { fontSize: 32, textAlign: 'center', verticalAlign: 'center' } },
              { id: 'bt2', tur: 'parametre-metin', parametreAnahtari: 'makine', x: 5, y: 24, genislik: 420, yukseklik: 36, stil: { fontSize: 22, fontWeight: '700', color: '#ffffff', verticalAlign: 'center' } },
              { id: 'bt7', tur: 'sabit-metin', icerik: '◆ BAKIM TALEBİ', x: 3, y: 92, genislik: 200, yukseklik: 16, stil: { fontSize: 8, fontWeight: '600', color: 'rgba(255,255,255,0.25)', letterSpacing: 2 } },
            ],
          } as ISablon,
          altKartSablonlari: [
            {
              id: 'hmi.bakim.guncelleme',
              baslik: 'Güncelleme',
              simge: '🔄',
              parametreler: [
                {
                  turu: 'Açılır Kutu', ismi: 'durum', baslik: 'Durum', ayarlar: {
                    zorunlu: true,
                    itemSablon: { aktif: true, simgeGoster: false, renkGoster: true, aciklamaGoster: false, resimGoster: false },
                    secenekler: [
                      { label: 'Bekliyor', value: 'Bekliyor', renk: '#8c8c8c' },
                      { label: 'İnceleniyor', value: 'İnceleniyor', renk: '#1890ff' },
                      { label: 'Parça Bekleniyor', value: 'Parça Bekleniyor', renk: '#fa8c16' },
                      { label: 'Onarılıyor', value: 'Onarılıyor', renk: '#13c2c2' },
                      { label: 'Tamamlandı', value: 'Tamamlandı', renk: '#52c41a' },
                    ],
                  }
                },
                { turu: 'Yazı', ismi: 'tahminiSure', baslik: 'Tahmini Süre' },
                { turu: 'Yazı Alanı', ismi: 'notlar', baslik: 'Notlar' },
              ],
              sablon: {
                genislik: 520, yukseklik: 180, mod: 'serbest',
                arkaPlan: { tur: 'gradient', deger: 'linear-gradient(160deg, #1a1a2e 0%, #2d1b1b 50%, #3a1a1a 100%)' },
                bolgeler: [],
                elementler: [
                  { id: 'btg0', tur: 'sekil', sekilTuru: 'dikdortgen', x: 0, y: 0, genislik: 6, yukseklik: 180, stil: { fill: '#e53935' } },
                  { id: 'btg1', tur: 'sabit-metin', icerik: '🔄', x: 4, y: 8, genislik: 40, yukseklik: 40, stil: { fontSize: 24, textAlign: 'center', verticalAlign: 'center' } },
                  { id: 'btg2', tur: 'sabit-metin', icerik: 'BAKIM GÜNCELLEMESİ', x: 14, y: 8, genislik: 220, yukseklik: 18, stil: { fontSize: 9, fontWeight: '700', color: '#ef9a9a', letterSpacing: 2, verticalAlign: 'center' } },
                  { id: 'btg3a', tur: 'sekil', sekilTuru: 'dikdortgen', x: 15, y: 35, genislik: 180, yukseklik: 34, stil: { fill: 'rgba(229,57,53,0.15)', borderRadius: 17 } },
                  { id: 'btg3', tur: 'parametre-render', parametreAnahtari: 'durum', x: 15, y: 35, genislik: 180, yukseklik: 34, stil: { fontSize: 15, fontWeight: '700', color: '#ffffff', textAlign: 'center', verticalAlign: 'center' } },
                ],
              } as ISablon,
            },
            { id: 'hmi.bakim.durum', baslik: 'Durum Güncelleme', simge: '🔄', bilesen: 'durum-guncelleme' },
            { id: 'hmi.bakim.gorev', baslik: 'Görev', simge: '✅', bilesen: 'gorev' },
            { id: 'hmi.bakim.maliyet', baslik: 'Maliyet', simge: '💰', bilesen: 'maliyet-kalemi' },
          ],
        },
      ],
    }, */
  ];

  icerikEkle(ek: any = null) {
    if (!ek) {
      ek = { turu: 'UYGULAMAICERIK', _id: '', parametreler: [] };
    }
    this.kart?.veri?.icerikler?.push({
      _id: new FikoYTId().toString(), aciklama: '', html: '', ek, sifre: null,
    }) ?? 0;
  }

  sifirla() {
    this.kart = {
      _id: new FikoYTId().toString(),
      vt: 'FikoYT.sistem.hareketler' as IVT,
      yol: 'FikoYT.sistem.hareketler.kalem' as IYollar,
      turu: IKartTuru.KART,
      gizlilik: 'Herkese Açık',
      kisiler: [],
      veri: {
        solSimge: { aciklama: undefined, baslik: 'HMI', renkArka: '#722ed1', renkYazi: '#fff' },
        kurdela: { aciklama: undefined, baslik: 'Yönetim', renkArka: undefined, renkYazi: undefined },
        icerikler: [],
      },
    };
    this.icerikEkle();
  }

  aktifEtSonSayfa() {
    this.aktifIcerikNo = (this.kart?.veri?.icerikler?.length ?? 1) - 1;
  }
}
